import React, { useState } from 'react';
import cambioEstadoService from "../../services/cambioEstadoService";
import { obtenerSiguienteEstadoART } from "../../services/art/artEstadoService";
import { toast } from "react-toastify";
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import DescriptionIcon from '@mui/icons-material/Description';
import SendIcon from '@mui/icons-material/Send';

function GestorComisionMedica({ tramite, onAvanzar }) {
    const [cargando, setCargando] = useState(false);
    const [observaciones, setObservaciones] = useState("");

    const handleAvanzar = async () => {
        setCargando(true);
        try {
            const siguienteEstado = await obtenerSiguienteEstadoART(tramite.nombreEstadoActual, "Resolución SRT");

            if (!siguienteEstado) {
                toast.error("No se pudo obtener el estado destino: Resolución SRT.");
                setCargando(false);
                return;
            }

            const comentarioFinal = observaciones.trim()
                ? `Iniciado en Comisión Médica de la SRT.\nObservaciones: ${observaciones}`
                : `Iniciado en Comisión Médica de la SRT.`;

            await cambioEstadoService.cambiarEstado(tramite.idTramite, {
                idEstado: siguienteEstado.id || siguienteEstado.idEstado,
                comentario: comentarioFinal
            });

            toast.success("Avanzando a Resolución SRT...");
            onAvanzar();
        } catch (error) {
            console.error("Error al avanzar:", error);
            toast.error("Error: " + (error.response?.data?.message || error.message));
        } finally {
            setCargando(false);
        }
    };

    return (
        <div className="card shadow-lg border-0 rounded-4 p-4 mb-4">
            {/* Header con Ícono y Título */}
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="fw-bold text-dark mb-0">
                    <AccountBalanceIcon className="me-2" style={{ fontSize: '1.5rem' }} />
                    Iniciado en Comisión Médica (SRT)
                </h4>
                <span className="badge bg-secondary rounded-pill px-3 py-2">
                    <AccountBalanceIcon fontSize="small" className="me-1" />
                    Superintendencia
                </span>
            </div>

            {/* Alert informativo */}
            <div className="alert alert-info border-0 rounded-3">
                <strong>Información:</strong>
                <p className="mb-0 mt-1">
                    El trámite se encuentra en la Comisión Médica de la SRT para su análisis y resolución.
                    Opcionalmente, agregue observaciones y avance al siguiente estado.
                </p>
            </div>

            {/* --- SECCIÓN DE OBSERVACIONES --- */}
            <div className="mt-4">
                <h6 className="fw-semibold text-primary mb-3">
                    <DescriptionIcon fontSize="small" className="me-2 mb-1" />
                    Observaciones
                </h6>
                <textarea
                    className="form-control"
                    rows="4"
                    placeholder="Agregue observaciones o comentarios sobre el seguimiento en la Comisión Médica..."
                    value={observaciones}
                    onChange={(e) => setObservaciones(e.target.value)}
                    disabled={cargando}
                    style={{ borderRadius: '0.5rem',
                        border: '1px solid #e0e0e0',
                        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", 
                        lineHeight: '1.5' }}
                />
                <small className="text-muted mt-2 d-block">
                    {observaciones.length}/500 caracteres - Estos comentarios se guardarán en el historial del trámite.
                </small>
            </div>

            {/* --- ACCIONES DE SALIDA --- */}
            <div className="d-flex justify-content-center flex-wrap gap-3 mt-4 pt-3 border-top">
                <button
                    className="btn btn-success d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                    onClick={handleAvanzar}
                    disabled={cargando}
                >
                    {cargando ? (
                        <>
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Procesando...
                        </>
                    ) : (
                        <>
                            <SendIcon fontSize="small" />
                            Avanzar a Resolución SRT
                        </>
                    )}
                </button>
            </div>
        </div>
    );
}

export default GestorComisionMedica;

